module.exports = __webpack_public_path__ + "img/product.d1c065bb.png";